var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsingGrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 246,
    height: 189,
    viewBox: "0 0 246 189",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.0108 68.0219L99.1647 42.8617C98.7288 42.1545 98.2704 41.4649 97.793 40.7891L72.0186 66.5661L74.0108 68.0219Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.746 64.9079L96.1071 38.5381C95.5933 37.9062 95.062 37.297 94.5105 36.6953L67.7588 63.4546L69.746 64.9079Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7617 54.1415L88.5617 31.3391C87.8972 30.8517 87.2189 30.3781 86.5255 29.9297L65.7642 50.696V54.1415H65.7617Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7617 46.7634L84.0748 28.4515C83.3262 28.0383 82.5674 27.6539 81.7937 27.2871L65.7617 43.3203V46.7634Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7617 39.3838L79.0465 26.0953C78.2099 25.7724 77.3545 25.4835 76.4916 25.2109L65.7617 35.9408V39.3838Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7617 32.0043L73.3965 24.3683C72.4431 24.1522 71.4733 23.9789 70.4973 23.8281L65.7617 28.565V32.0043Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7617 61.5171L92.5675 34.7051C91.9784 34.1423 91.3804 33.5934 90.7587 33.0684L65.7617 58.0716V61.5171Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.945 23.4446C66.5493 23.4195 66.1574 23.4044 65.7617 23.3906V24.6317L66.945 23.4446Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2774 71.1368L101.713 47.6949C101.364 46.9073 100.991 46.1298 100.592 45.3711L76.2852 69.6834L78.2774 71.1368Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8053 77.37L104.911 59.2616C104.787 58.2592 104.637 57.2656 104.444 56.2871L84.8193 75.9154L86.8053 77.37Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5385 74.251L103.669 53.1179C103.422 52.2348 103.15 51.3618 102.844 50.5039L80.5488 72.8039L82.5385 74.251Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3339 83.6078L103.722 75.2144C104.127 73.7761 104.45 72.3027 104.692 70.8066L93.3467 82.1545L95.3339 83.6078Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0676 80.4913L105.16 66.3963C105.198 65.6866 105.22 64.9731 105.22 64.2471C105.22 63.8024 105.203 63.364 105.189 62.9219L89.0791 79.038L91.0676 80.4913Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8333 86.1582C99.7917 84.6533 100.655 83.0882 101.415 81.459L97.6123 85.2625L98.8333 86.1582Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7608_8652",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 246,
    height: 189
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H246V188.547H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7608_8652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.085 188.43H14.1113C6.50548 188.43 0.320312 182.241 0.320312 174.636V13.6821C0.320312 6.07371 6.508 -0.115234 14.1113 -0.115234H232.085C239.69 -0.115234 245.876 6.07747 245.876 13.6821V174.636C245.878 182.241 239.69 188.43 232.085 188.43ZM14.1113 5.40419C9.54908 5.40419 5.83471 9.11605 5.83471 13.6821V174.636C5.83471 179.199 9.54908 182.914 14.1113 182.914H232.085C236.647 182.914 240.36 179.199 240.36 174.636V13.6821C240.36 9.11605 236.647 5.40419 232.085 5.40419H14.1113Z",
    fill: "white"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M140.894 54.1953H151.483V88.8569H140.894V54.1953Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M157.325 57.0879H167.911V88.8604H157.325V57.0879Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M173.749 62.8672H184.336V88.8615H173.749V62.8672Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M190.177 48.416H200.763V88.857H190.177V48.416Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M206.604 48.416H217.19V88.857H206.604V48.416Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M216.662 112.6L161.07 139.919L140.836 127.671L104.343 144.26L45.2198 149.48L21.9375 166.032H216.494L216.662 112.6Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2636 105.04C41.7136 105.04 23.3691 86.6946 23.3691 64.1371C23.3691 42.0971 40.8884 24.0804 62.7274 23.2715V63.7351H62.7475L96.928 88.7157C96.9242 88.7157 96.9242 88.7157 96.9242 88.7157C89.4603 98.6228 77.5949 105.04 64.2636 105.04Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsingGrap);
export default __webpack_public_path__ + "static/media/Using-grap.a922284657d9564c9af4d7e7b7d60ec0.svg";
export { ForwardRef as ReactComponent };